import { GetterTree } from 'vuex';
import { ConsumerApplicationState, ConsumerApplicationStatus, ConsumerApplication, ConsumerApplicationResponse } from './types';
import { RootState } from '../types';

export const getters: GetterTree<ConsumerApplicationState, RootState> = {
    consumerApplication(state): ConsumerApplication {
        if (state.consumerApplication) {
            return state.consumerApplication;
        }
        return {};
    },

    processingStatus(state): ConsumerApplicationStatus {
        return state.processingStatus;
    },

    consumerApplicationResponse(state): ConsumerApplicationResponse {
        if (state.consumerApplicationResponse) {
            return state.consumerApplicationResponse;
        }
        return {};
    },
    maskedSSN(state): string {
        if(state.consumerApplication != undefined 
            && state.consumerApplication.identity != undefined){
            const taxId: string = state.consumerApplication.identity.taxId || '';
            if (taxId != undefined && taxId != '') {
                const lastFour = taxId.substr(taxId.length - 4);
                return '###-##-'.concat(lastFour);
            }
        }
        return '';
    },

    accountConversionConsent(state): boolean {
        let consent = false;
        if(state.consumerApplication != undefined && state.consumerApplication.accountConversion != undefined ){
            consent = state.consumerApplication.accountConversion.consent || false;
        }
        return consent;
    },
};
